import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormIdentifierDirective } from './form-identifier.directive';
import { FormValidationDirective } from './form-validation.directive';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    declarations: [FormValidationDirective, FormIdentifierDirective],
    exports: [FormValidationDirective, FormIdentifierDirective]
})
export class FormDirectivesModule {}
